// extracted by mini-css-extract-plugin
module.exports = {"newsWrapper":"home-news-module--news-wrapper--3nTh-","h4":"home-news-module--h4--2zo07","news":"home-news-module--news--23fFo"};